// 媒体打分数据公共管理

// 原始明细数据（用于明细弹窗展示）
const originalDetailData = {
  '小红书': {
    name: '小红书',
    richness: 6,       // 曝光类3个 + 内容类2个 + 效果类1个 = 6个标签
    algorithm: 9,      // 用户行为因子5个 + 用户信息因子4个 = 9个标签
    brand: 3,          // 3个标签
    platform: 1,       // 1个标签
    influencer: 1,     // 1个标签
    hot: 1,            // 1个标签
    history: 1         // 1个标签
  },
  '抖音': {
    name: '抖音',
    richness: 12,      // 曝光类5个 + 内容类4个 + 效果类3个 = 12个标签
    algorithm: 14,     // 用户行为因子8个 + 用户信息因子6个 = 14个标签
    brand: 5,          // 5个标签
    platform: 2,       // 2个标签
    influencer: 2,     // 2个标签
    hot: 1,            // 1个标签
    history: 2         // 2个标签
  },
  '快手': {
    name: '快手',
    richness: 19,      // 曝光类10个 + 内容类5个 + 效果类4个 = 19个标签
    algorithm: 19,     // 用户行为因子10个 + 用户信息因子9个 = 19个标签
    brand: 6,          // 6个标签
    platform: 2,       // 2个标签
    influencer: 2,     // 2个标签
    hot: 1,            // 1个标签
    history: 2         // 2个标签
  },
  '微博': {
    name: '微博',
    richness: 3,       // 曝光类2个 + 内容类1个 = 3个标签
    algorithm: 4,      // 用户行为因子3个 + 用户信息因子1个 = 4个标签
    brand: 1,          // 1个标签
    platform: 1,       // 1个标签
    influencer: 1,     // 1个标签
    hot: 1,            // 1个标签
    history: 1         // 1个标签
  },
  'B站': {
    name: 'B站',
    richness: 5,       // 曝光类3个 + 内容类2个 = 5个标签
    algorithm: 2,      // 用户行为因子2个 = 2个标签
    brand: 1,          // 1个标签
    platform: 1,       // 1个标签
    influencer: 1,     // 1个标签
    hot: 1,            // 1个标签
    history: 1         // 1个标签
  },
  // 新增媒体
  '微信': {
    name: '微信',
    richness: 10,
    algorithm: 8,
    brand: 6,
    platform: 3,
    influencer: 2,
    hot: 2,
    history: 3
  },
  '知乎': {
    name: '知乎',
    richness: 7,
    algorithm: 7,
    brand: 3,
    platform: 2,
    influencer: 2,
    hot: 1,
    history: 2
  },
  '携程': {
    name: '携程',
    richness: 6,
    algorithm: 5,
    brand: 4,
    platform: 2,
    influencer: 1,
    hot: 1,
    history: 2
  },
  '去哪儿': {
    name: '去哪儿',
    richness: 5,
    algorithm: 5,
    brand: 3,
    platform: 2,
    influencer: 1,
    hot: 1,
    history: 2
  },
  '高德地图': {
    name: '高德地图',
    richness: 6,
    algorithm: 6,
    brand: 4,
    platform: 2,
    influencer: 1,
    hot: 1,
    history: 2
  },
  '滴滴出行': {
    name: '滴滴出行',
    richness: 7,
    algorithm: 7,
    brand: 4,
    platform: 2,
    influencer: 1,
    hot: 1,
    history: 2
  },
  '爱奇艺': {
    name: '爱奇艺',
    richness: 8,
    algorithm: 6,
    brand: 4,
    platform: 2,
    influencer: 2,
    hot: 2,
    history: 2
  },
  '腾讯视频': {
    name: '腾讯视频',
    richness: 8,
    algorithm: 6,
    brand: 4,
    platform: 2,
    influencer: 2,
    hot: 2,
    history: 2
  },
  '优酷': {
    name: '优酷',
    richness: 7,
    algorithm: 5,
    brand: 3,
    platform: 2,
    influencer: 1,
    hot: 1,
    history: 2
  },
  '芒果': {
    name: '芒果',
    richness: 7,
    algorithm: 5,
    brand: 3,
    platform: 2,
    influencer: 1,
    hot: 1,
    history: 2
  },
  '搜狐新闻': {
    name: '搜狐新闻',
    richness: 6,
    algorithm: 5,
    brand: 3,
    platform: 2,
    influencer: 1,
    hot: 1,
    history: 2
  },
  '网易新闻': {
    name: '网易新闻',
    richness: 6,
    algorithm: 5,
    brand: 3,
    platform: 2,
    influencer: 1,
    hot: 1,
    history: 2
  },
  '凤凰新闻': {
    name: '凤凰新闻',
    richness: 6,
    algorithm: 5,
    brand: 3,
    platform: 2,
    influencer: 1,
    hot: 1,
    history: 2
  },
  '淘宝': {
    name: '淘宝',
    richness: 9,
    algorithm: 8,
    brand: 6,
    platform: 3,
    influencer: 2,
    hot: 2,
    history: 3
  },
  '京东': {
    name: '京东',
    richness: 8,
    algorithm: 7,
    brand: 5,
    platform: 3,
    influencer: 2,
    hot: 2,
    history: 3
  }
}

// 媒体打分列表数据（初始为空，计算后保存）
let mediaScoreListData = {
  '小红书': {
    name: '小红书',
    richness: null,
    algorithm: null,
    brand: null,
    platform: null,
    influencer: null,
    hot: null,
    history: null
  },
  '抖音': {
    name: '抖音',
    richness: null,
    algorithm: null,
    brand: null,
    platform: null,
    influencer: null,
    hot: null,
    history: null
  },
  '快手': {
    name: '快手',
    richness: null,
    algorithm: null,
    brand: null,
    platform: null,
    influencer: null,
    hot: null,
    history: null
  },
  '微博': {
    name: '微博',
    richness: null,
    algorithm: null,
    brand: null,
    platform: null,
    influencer: null,
    hot: null,
    history: null
  },
  'B站': {
    name: 'B站',
    richness: null,
    algorithm: null,
    brand: null,
    platform: null,
    influencer: null,
    hot: null,
    history: null
  },
  // 新增媒体
  '微信': {
    name: '微信',
    richness: null,
    algorithm: null,
    brand: null,
    platform: null,
    influencer: null,
    hot: null,
    history: null
  },
  '知乎': {
    name: '知乎',
    richness: null,
    algorithm: null,
    brand: null,
    platform: null,
    influencer: null,
    hot: null,
    history: null
  },
  '携程': {
    name: '携程',
    richness: null,
    algorithm: null,
    brand: null,
    platform: null,
    influencer: null,
    hot: null,
    history: null
  },
  '去哪儿': {
    name: '去哪儿',
    richness: null,
    algorithm: null,
    brand: null,
    platform: null,
    influencer: null,
    hot: null,
    history: null
  },
  '高德地图': {
    name: '高德地图',
    richness: null,
    algorithm: null,
    brand: null,
    platform: null,
    influencer: null,
    hot: null,
    history: null
  },
  '滴滴出行': {
    name: '滴滴出行',
    richness: null,
    algorithm: null,
    brand: null,
    platform: null,
    influencer: null,
    hot: null,
    history: null
  },
  '爱奇艺': {
    name: '爱奇艺',
    richness: null,
    algorithm: null,
    brand: null,
    platform: null,
    influencer: null,
    hot: null,
    history: null
  },
  '腾讯视频': {
    name: '腾讯视频',
    richness: null,
    algorithm: null,
    brand: null,
    platform: null,
    influencer: null,
    hot: null,
    history: null
  },
  '优酷': {
    name: '优酷',
    richness: null,
    algorithm: null,
    brand: null,
    platform: null,
    influencer: null,
    hot: null,
    history: null
  },
  '芒果': {
    name: '芒果',
    richness: null,
    algorithm: null,
    brand: null,
    platform: null,
    influencer: null,
    hot: null,
    history: null
  },
  '搜狐新闻': {
    name: '搜狐新闻',
    richness: null,
    algorithm: null,
    brand: null,
    platform: null,
    influencer: null,
    hot: null,
    history: null
  },
  '网易新闻': {
    name: '网易新闻',
    richness: null,
    algorithm: null,
    brand: null,
    platform: null,
    influencer: null,
    hot: null,
    history: null
  },
  '凤凰新闻': {
    name: '凤凰新闻',
    richness: null,
    algorithm: null,
    brand: null,
    platform: null,
    influencer: null,
    hot: null,
    history: null
  },
  '淘宝': {
    name: '淘宝',
    richness: null,
    algorithm: null,
    brand: null,
    platform: null,
    influencer: null,
    hot: null,
    history: null
  },
  '京东': {
    name: '京东',
    richness: null,
    algorithm: null,
    brand: null,
    platform: null,
    influencer: null,
    hot: null,
    history: null
  }
}

// 权重配置
const weightConfig = {
  richness: 20,    // 资源丰富度权重
  algorithm: 20,   // 算法用户看重度权重
  brand: 15,       // 品牌合作成熟度权重
  platform: 15,    // 平台流量规模权重
  influencer: 10,  // 达人资源规模权重
  hot: 10,         // 热榜热度规模权重
  history: 10      // 历史费效优势权重
}

// 加权打分计算规则
const weightedScoreRules = {
  attention: {
    // 关注层 = 资源丰富度*20% + 平台流量规模*15% + 热榜热度规模*10%
    richness: 0.2,
    platform: 0.15,
    hot: 0.1
  },
  interest: {
    // 兴趣层 = 算法用户看重度*20% + 达人资源规模*10%
    algorithm: 0.2,
    influencer: 0.1
  },
  recognition: {
    // 认可层 = 品牌合作成熟度*15% + 历史费效优势*10%
    brand: 0.15,
    history: 0.1
  }
}

// 获取原始明细数据（用于明细弹窗）
export function getOriginalDetailData() {
  return Object.values(originalDetailData)
}

// 获取原始明细数据（单个媒体）
export function getOriginalMediaDetail(mediaName) {
  return originalDetailData[mediaName] || null
}

// 获取媒体打分列表数据
export function getMediaScoreList() {
  return Object.values(mediaScoreListData).map(item => ({
    ...item,
    // 将null值转换为'-'用于显示
    richness: item.richness === null ? '-' : item.richness,
    algorithm: item.algorithm === null ? '-' : item.algorithm,
    brand: item.brand === null ? '-' : item.brand,
    platform: item.platform === null ? '-' : item.platform,
    influencer: item.influencer === null ? '-' : item.influencer,
    hot: item.hot === null ? '-' : item.hot,
    history: item.history === null ? '-' : item.history
  }))
}

// 获取权重配置
export function getWeightConfig() {
  return { ...weightConfig }
}

// 更新权重配置
export function updateWeightConfig(weights) {
  Object.assign(weightConfig, weights)
}

// 校验权重总和是否为100%
export function validateWeights(weights) {
  const total = Object.values(weights).reduce((sum, val) => sum + (val || 0), 0)
  return total === 100
}

// 根据权重计算媒体打分列表数据
export function calculateMediaScores(weights) {
  const mediaNames = Object.keys(originalDetailData)
  
  mediaNames.forEach(mediaName => {
    const originalData = originalDetailData[mediaName]
    
    // 按权重计算各维度分数
    const calculatedData = {
      name: mediaName,
      richness: parseFloat((originalData.richness * weights.richness / 100).toFixed(2)),
      algorithm: parseFloat((originalData.algorithm * weights.algorithm / 100).toFixed(2)),
      brand: parseFloat((originalData.brand * weights.brand / 100).toFixed(2)),
      platform: parseFloat((originalData.platform * weights.platform / 100).toFixed(2)),
      influencer: parseFloat((originalData.influencer * weights.influencer / 100).toFixed(2)),
      hot: parseFloat((originalData.hot * weights.hot / 100).toFixed(2)),
      history: parseFloat((originalData.history * weights.history / 100).toFixed(2))
    }
    
    mediaScoreListData[mediaName] = calculatedData
  })
  
  return getMediaScoreList()
}

// 保存媒体打分列表数据
export function saveMediaScoreList() {
  // 这里实际上数据已经在calculateMediaScores中更新了
  // 这个函数主要用于触发保存操作的反馈
  return true
}

// 计算加权打分（基于保存的媒体打分列表数据）
export function calculateWeightedScore(mediaName) {
  const mediaData = mediaScoreListData[mediaName]
  if (!mediaData || mediaData.richness === null) {
    // 如果没有计算过的数据，返回空值
    return {
      name: mediaName,
      attention: 0,
      interest: 0,
      recognition: 0,
      finalScore: 0
    }
  }

  // 计算关注层分数 = 资源丰富度*20% + 平台流量规模*15% + 热榜热度规模*10%
  const attention = parseFloat((
    mediaData.richness * weightedScoreRules.attention.richness +
    mediaData.platform * weightedScoreRules.attention.platform +
    mediaData.hot * weightedScoreRules.attention.hot
  ).toFixed(2))

  // 计算兴趣层分数 = 算法用户看重度*20% + 达人资源规模*10%
  const interest = parseFloat((
    mediaData.algorithm * weightedScoreRules.interest.algorithm +
    mediaData.influencer * weightedScoreRules.interest.influencer
  ).toFixed(2))

  // 计算认可层分数 = 品牌合作成熟度*15% + 历史费效优势*10%
  const recognition = parseFloat((
    mediaData.brand * weightedScoreRules.recognition.brand +
    mediaData.history * weightedScoreRules.recognition.history
  ).toFixed(2))

  return {
    name: mediaName,
    attention,
    interest,
    recognition,
    finalScore: 0
  }
}

// 计算所有媒体的加权打分
export function calculateAllWeightedScores() {
  const mediaNames = Object.keys(mediaScoreListData)
  return mediaNames.map(name => calculateWeightedScore(name))
}

// 获取加权打分规则
export function getWeightedScoreRules() {
  return { ...weightedScoreRules }
} 